import script from "./Empty.vue?vue&type=script&lang=ts&setup=true"
export * from "./Empty.vue?vue&type=script&lang=ts&setup=true"

import "./Empty.vue?vue&type=style&index=0&id=1a94f4d8&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a94f4d8"]])

export default __exports__